import request from '@/utils/request'

/**
 * 通知管理API模块
 */
const noticeApi = {
  /**
   * 分页查询通知列表
   */
  queryNotices(data) {
    return request({url: '/service/notice/queryNotices',method: 'post',data})
  },
  // 新增通知
  addNotice(data) {
    return request({url: '/service/notice/addNotice',method: 'post',data})
  },
  // 修改通知状态
  upNoticeStat(id,stat) {
    return request({url: '/service/notice/upNoticeStat?id='+id+'&stat='+stat,method: 'put'})
  },
  // 修改通知信息
  updateNotice(data) {
    return request({url: '/service/notice/updateNotice',method: 'post',data})
  },
  // 统计我的未读消息数
  unreadNoticeNum() {
    return request({url: '/service/notice/unreadNoticeNum',method: 'get'})
  },
  // 分页查看我的消息
  queryMyNotices(data) {
    return request({url: '/service/notice/queryMyNotices',method: 'post',data})
  },
  // 全部已读我的消息
  allRead() {
    return request({url: '/service/notice/allRead',method: 'put'})
  },
  // 已读我的消息
  readNotice(id) {
    return request({url: '/service/notice/readNotice?id='+id,method: 'put'})
  },
  // 查询通知对应的用户
  noticeUsers(id) {
    return request({url: '/service/notice/noticeUsers?id='+id,method: 'get'})
  },
  // 查看我的弹窗消息
  queryMyOpenNotices() {
    return request({url: '/service/notice/queryMyOpenNotices',method: 'get'})
  },
}

export default noticeApi